import React, { useState, useImperativeHandle } from 'react';
import PropertyPopup from './components/PropertyPopup'

let extraDivsDictionary = {
    'Custom': ['Mass Flow (tonnes/day)'],
    'Filters - Plate and frame': ['Mass Flow (tonnes/day)', 'Solid Concentration (kg/m3)', 'Cycle Time (hrs)', 'Pump Efficiency (%)', 'Operating Pressure (Pa)', 'Density Liquid (kg/m3)', 'Density Solid (kg/m3)'],
    'Tanks - cone roof':  ['Mass Flow (tonnes/day)', 'Residence Time (hrs)', 'Operating Level (%)', 'Density (kg/m3)'],
    'Tanks + Agitator':  ['Mass Flow (tonnes/day)', 'Residence Time (hrs)', 'Operating Level (%)', 'Tank Height (m)','Density (kg/m3)', 'Agitation Application'],
    'Reactors - Jacketed, agitated': ['Mass Flow (tonnes/day)', 'Residence Time (hrs)', 'Operating Level (%)', 'Density (kg/m3)', 'Agitation Application', 'Inlet Temperature (°C)', 'Reaction Temperature (°C)', 'Heat Transfer Coefficient (W/m2°C)'],
    'Extruder - Screw' : ['Mass Flow (tonnes/day)'],
    // 'Pressure vessels - Vertical': ['S (shell mass- m3)'],
    'Agitators & mixers - Static mixer': ['Mass Flow (tonnes/day)', 'Density (kg/m3)'],
    'Screens - Grizzly Bar':['Mass Flow (tonnes/day)', 'Solid Concentration (kg/m3)', 'Cycle Time (hrs)', 'Density Liquid (kg/m3)', 'Density Solid (kg/m3)'],
    'Pumps and drivers - Single stage centrifugal': ['Mass Flow (tonnes/day)', 'Density (kg/m3)', 'Operating Pressure (Pa)', 'Pump Efficiency (%)'],
    'Pumps - Rotary Screw': ['Mass Flow (tonnes/day)', 'Density (kg/m3)', 'Operating Pressure (Pa)', 'Pump Efficiency (%)'],
    'Centrifuges - Continuous Extraction (<2.2 L/s)': ['Mass Flow (tonnes/day)', 'Density (kg/m3)'],
    'Centrifuges - Continuous Extraction (>2.2 L/s)': ['Mass Flow (tonnes/day)', 'Density (kg/m3)'],
    //'Crushers - Jaw crusher': ['Mass Flow (tonnes/h)'],
    //'Crushers - Gyratory crusher': ['Mass Flow (tonnes/h)'],
    //'Crushers - Reversible hammer mill': ['Mass Flow (tonnes/h)'],
    //'Crushers - Ball mill': ['Mass Flow (tonnes/hr)'],
    //'Haulage - Electric Fleet': ['Mass Flow (tonnes/h)'],
    //'Haulage - Diesel Fleet': ['Mass Flow (tonnes/h)'],
    'Dryers - Spray dryer': ['Mass Flow (tonnes/day)'],
    'Pressure Exchange + Rotary Pump': ['Mass Flow (tonnes/day)', 'Density (kg/m3)', 'Operating Pressure (Pa)', 'Pump Efficiency (%)', 'PX Flow (m3/day)', 'Energy Recovery (%)']

};

const FinancialPopup = React.forwardRef((props, ref) => {
    const [popups, setPopups] = useState([]);

    useImperativeHandle(ref, () => ({
        popups,
        addFinancialStreamPropertyPopup,
        hideFinancialStreamPropertyPopup,
        openFinancialStreamPropertyPopup,
        closeFinancialStreamPropertyPopup
    }));

    const addFinancialStreamPropertyPopup = (getMADropdownData, graph, modelId, econVars,pageX,pageY, orgSectors) => {
        if(popups){
            const popupExists = popups.some(
                popup => popup.id === modelId
            );
            if(!popupExists){
                setPopups(prevPopups => [...prevPopups, { getMADropdownData: getMADropdownData, id: modelId, isOpen: true, graph, modelId, econVars,pageX,pageY, orgSectors: orgSectors }]);
            }
        }
    }

    const openFinancialStreamPropertyPopup = (id) => {
        if(popups){
            const popupExists = popups.some(
                popup => popup.id === id
            );
            if(popupExists){
                setPopups(prevPopups => prevPopups.map(popup =>
                    popup.id === id ? { ...popup, isOpen: true } : popup
                ));
            }
        }
    }

    const hideFinancialStreamPropertyPopup = (id) => {
        if(popups){
            const popupExists = popups.some(
                popup => popup.id === id
            );
            if(popupExists){
                setPopups(prevPopups => prevPopups.map(popup =>
                    popup.id === id ? { ...popup, isOpen: false } : popup
                ));
            }
        }
    }

    const closeFinancialStreamPropertyPopup = (id) => {
        setPopups(prevPopups => prevPopups.filter(popup => popup.id !== id));
    }

    return (
        <div className="financial-popup-container">
        {popups.map(popup =>
            <PropertyPopup
            getMADropdownData={popup.getMADropdownData}
            isAuthenticated={props.isAuthenticated}
            getIdTokenClaims={props.getIdTokenClaims}
            key={`${popup.id}-${props.simulationVersion || 0}`}
            isOpen={popup.isOpen}
            onOpen={() => openFinancialStreamPropertyPopup(popup.id)}
            onClose={() => closeFinancialStreamPropertyPopup(popup.id)}
            updateGraphs={props.updateGraphs}
            graph={popup.graph}
            modelId={popup.modelId}
            econVars={popup.econVars}
            reCalculate={props.reCalculate}
            pageX={popup.pageX}
            pageY={popup.pageY}
            orgSectors={popup.orgSectors}
        />
        )}
    </div>
    );
});

export default FinancialPopup;
